import { useReducer, useCallback, useEffect } from 'react';
import reducer, { initialState } from './reducer';
import { fetching, success, error } from './actions';
import { SUCCESS } from './actionTypes';
import { ArrayActionType } from '../../reducers/arrayActions';
import { fetchJSON } from '../fetch';

export function combineReducers(reducers) {
    return (state = {}, action) => {
        const newState = {};
        for (let key in reducers) {
            newState[key] = reducers[key](state[key], action);
        }
        return newState;
    }
}

export function useApiRequest(endpoint: string, { method = 'GET', params = {} } = {}): [any, (options?) => Promise<any>] {
    const [state, dispatch] = useReducer<(state: any, actions: any) => any>(reducer, initialState);

    const makeRequest = useCallback(async (options = {}) => {
        dispatch(fetching());

        try {
            const response = await fetchJSON<any>(endpoint, {
                ...params,
                ...options,
                method
            });

            if (response.statusCode && response.statusCode !== 200) {
                throw response;
            } else {
                dispatch(success(response));
            }
        } catch (e) {
            console.error(e);
            dispatch(error(e));
        }
    }, [endpoint, method, params]);

    return [state, makeRequest];
};

export function useApiReducer(url, reducer, initialState = []) {
    const [api, callApi] = useApiRequest(url);
    const [state, dispatch] = useReducer(reducer, initialState) as any;

    useEffect(() => {
        callApi();
    }, [url]);

    useEffect(() => {
        if (api.status === SUCCESS) {
            dispatch({ type: ArrayActionType.SET, value: api.response })
        } else {
            dispatch({ type: ArrayActionType.SET, value: [] })
        }
    }, [api.status]);

    return [api, state, dispatch];
}